module.exports = __webpack_public_path__ + "static/media/trillo.bb7de387.jpg";